/**
 * @generated SignedSource<<0a99e6a02feb31970f50cac443aa4584>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type spSiteContextQuery$variables = {
  siteUrl: string;
};
export type spSiteContextQuery$data = {
  readonly getSharePointSite: {
    readonly name: string;
    readonly siteId: string;
    readonly siteUrl: string;
  } | null | undefined;
};
export type spSiteContextQuery = {
  response: spSiteContextQuery$data;
  variables: spSiteContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteUrl"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "siteUrl",
        "variableName": "siteUrl"
      }
    ],
    "concreteType": "SharePointSiteItem",
    "kind": "LinkedField",
    "name": "getSharePointSite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siteUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siteId",
        "storageKey": null
      },
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "spSiteContextQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "spSiteContextQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2b839cc8136a53ba9bf6e24c8f94f8c9",
    "id": null,
    "metadata": {},
    "name": "spSiteContextQuery",
    "operationKind": "query",
    "text": "query spSiteContextQuery(\n  $siteUrl: String!\n) {\n  getSharePointSite(siteUrl: $siteUrl) {\n    siteUrl\n    siteId\n    name: title\n  }\n}\n"
  }
};
})();

(node as any).hash = "0300538f273e651e9f8492780cbb4454";

export default node;
